var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquarefeet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.28,1H6.72A5.73,5.73,0,0,0,1,6.72V25.28A5.73,5.73,0,0,0,6.72,31H25.28A5.73,5.73,0,0,0,31,25.28V6.72A5.73,5.73,0,0,0,25.28,1ZM29,25.28A3.73,3.73,0,0,1,25.28,29H6.72A3.73,3.73,0,0,1,3,25.28V6.72A3.73,3.73,0,0,1,6.72,3H25.28A3.73,3.73,0,0,1,29,6.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,17.84a1,1,0,0,0-1,1v3.75L9.41,8h3.75a1,1,0,0,0,0-2H6.69A.69.69,0,0,0,6,6.69v6.47a1,1,0,0,0,2,0V9.41L22.59,24H18.84a1,1,0,0,0,0,2h6.47a.69.69,0,0,0,.69-.69V18.84A1,1,0,0,0,25,17.84Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquarefeet);
export default __webpack_public_path__ + "static/media/squarefeet.a869c9e722c83f73e40d22d54be5af82.svg";
export { ForwardRef as ReactComponent };